// src/pages/Convocations/data/convocation.data.js

import {
  FaCalendarAlt,
  FaCheckCircle,
  FaClock,
  FaListUl,
  FaTimesCircle,
} from "react-icons/fa";

export const DEFAULT_CONVOCATION_FILTERS = {
  searchQuery: "",
  selectedType: "",
  selectedPoste: "",
  selectedStatus: "",
  selectedActorId: "",
  showOnlyFuture: true,
  sortBy: "date-asc",
};

export const RESPONSE_STATUS_OPTIONS = [
  {
    value: "",
    label: "Tous les statuts",
  },
  {
    value: "pending",
    label: "En attente",
  },
  {
    value: "accepted",
    label: "Acceptées",
  },
  {
    value: "rejected",
    label: "Refusées",
  },
];

export const SORT_OPTIONS = [
  {
    value: "date-asc",
    label: "Date la plus proche",
  },
  {
    value: "date-desc",
    label: "Date la plus éloignée",
  },
  {
    value: "title-asc",
    label: "Événement A → Z",
  },
  {
    value: "status",
    label: "En attente en premier",
  },
];

export const RESPONSE_STATUS_META = {
  pending: {
    label: "En attente",
    Icon: FaClock,
    className: [
      "border-amber-200",
      "bg-amber-50",
      "text-amber-700",
      "dark:border-amber-800/80",
      "dark:bg-amber-950/40",
      "dark:text-amber-300",
    ].join(" "),
  },

  accepted: {
    label: "Acceptée",
    Icon: FaCheckCircle,
    className: [
      "border-emerald-200",
      "bg-emerald-50",
      "text-emerald-700",
      "dark:border-emerald-800/80",
      "dark:bg-emerald-950/40",
      "dark:text-emerald-300",
    ].join(" "),
  },

  rejected: {
    label: "Refusée",
    Icon: FaTimesCircle,
    className: [
      "border-rose-200",
      "bg-rose-50",
      "text-rose-700",
      "dark:border-rose-800/80",
      "dark:bg-rose-950/40",
      "dark:text-rose-300",
    ].join(" "),
  },
};

export const STAT_CARDS = [
  {
    key: "total",
    countKey: "total",
    label: "Toutes",
    description: "Toutes les convocations",
    status: "",
    Icon: FaListUl,
    className: [
      "border-slate-200",
      "bg-white",
      "text-slate-900",
      "dark:border-slate-700",
      "dark:bg-slate-900",
      "dark:text-white",
    ].join(" "),
    iconClassName: [
      "bg-slate-100",
      "text-slate-600",
      "dark:bg-slate-800",
      "dark:text-slate-300",
    ].join(" "),
  },

  {
    key: "pending",
    countKey: "pendingFuture",
    label: "À répondre",
    description: "Événements à venir",
    status: "pending",
    Icon: FaClock,
    className: [
      "border-amber-200",
      "bg-amber-50/80",
      "text-amber-950",
      "dark:border-amber-900/70",
      "dark:bg-amber-950/30",
      "dark:text-amber-100",
    ].join(" "),
    iconClassName: [
      "bg-amber-100",
      "text-amber-700",
      "dark:bg-amber-900/60",
      "dark:text-amber-300",
    ].join(" "),
  },

  {
    key: "accepted",
    countKey: "accepted",
    label: "Acceptées",
    description: "Réponses positives",
    status: "accepted",
    Icon: FaCheckCircle,
    className: [
      "border-emerald-200",
      "bg-emerald-50/80",
      "text-emerald-950",
      "dark:border-emerald-900/70",
      "dark:bg-emerald-950/30",
      "dark:text-emerald-100",
    ].join(" "),
    iconClassName: [
      "bg-emerald-100",
      "text-emerald-700",
      "dark:bg-emerald-900/60",
      "dark:text-emerald-300",
    ].join(" "),
  },

  {
    key: "rejected",
    countKey: "rejected",
    label: "Refusées",
    description: "Réponses négatives",
    status: "rejected",
    Icon: FaTimesCircle,
    className: [
      "border-rose-200",
      "bg-rose-50/80",
      "text-rose-950",
      "dark:border-rose-900/70",
      "dark:bg-rose-950/30",
      "dark:text-rose-100",
    ].join(" "),
    iconClassName: [
      "bg-rose-100",
      "text-rose-700",
      "dark:bg-rose-900/60",
      "dark:text-rose-300",
    ].join(" "),
  },
];

export const EMPTY_STATE_CONTENT = {
  noActor: {
    Icon: FaCalendarAlt,
    title: "Aucun profil acteur associé",
    description:
      "Votre compte n’est actuellement relié à aucun profil acteur. Vous devez créer ou rattacher une fiche acteur pour recevoir des convocations.",
  },

  noConvocation: {
    Icon: FaCalendarAlt,
    title: "Aucune convocation",
    description:
      "Vous n’avez pas encore reçu de convocation pour une compétition ou un événement de la Ligue.",
  },

  noResult: {
    Icon: FaCalendarAlt,
    title: "Aucun résultat",
    description:
      "Aucune convocation ne correspond aux filtres sélectionnés. Modifiez ou réinitialisez vos critères.",
  },
};